import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Logo from "../../Images/logo.png";

// const BASE_URL = "https://staging.pteshstudios.com";
const BASE_URL = "https://api.jeyshawnng.com";

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600;700&family=DM+Sans:wght@300;400;500&display=swap');

  .login__page {
    min-height: 100vh;
    display: flex;
    font-family: 'DM Sans', sans-serif;
    background: #f4f6f4;
  }

  .login__left {
    width: 48%;
    background: #0f3d1f;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 48px 52px;
    overflow: hidden;
  }
  .login__left::before {
    content: '';
    position: absolute;
    top: -80px; right: -80px;
    width: 320px; height: 320px;
    border-radius: 50%;
    background: rgba(255,255,255,0.04);
  }
  .login__left::after {
    content: '';
    position: absolute;
    bottom: -60px; left: -60px;
    width: 260px; height: 260px;
    border-radius: 50%;
    background: rgba(255,255,255,0.04);
  }
  .login__left-diamond {
    position: absolute;
    top: 42%; right: -40px;
    width: 180px; height: 180px;
    background: rgba(255,255,255,0.05);
    transform: rotate(45deg);
  }
  .login__left-line {
    position: absolute;
    bottom: 160px; right: 52px;
    width: 120px; height: 2px;
    background: rgba(255,255,255,0.15);
  }
  .login__logo { width: 350px; z-index: 2; }
  .login__logo img { width: 100%; }
  .login__left-body { position: relative; z-index: 2; }
  .login__left-label { font-size: 11px; letter-spacing: 3px; text-transform: uppercase; color: #3db87a; margin-bottom: 20px; font-weight: 500; }
  .login__left-title { font-family: 'Playfair Display', serif; font-size: 46px; font-weight: 700; color: #fff; line-height: 1.2; margin-bottom: 20px; max-width: 360px; }
  .login__left-title span { color: #3db87a; }
  .login__left-desc { font-size: 14px; color: rgba(255,255,255,0.55); line-height: 1.8; max-width: 320px; }
  .login__left-stats { display: flex; gap: 40px; position: relative; z-index: 2; }
  .login__stat { display: flex; flex-direction: column; gap: 4px; }
  .login__stat-num { font-family: 'Playfair Display', serif; font-size: 28px; font-weight: 700; color: #fff; line-height: 1; }
  .login__stat-label { font-size: 11px; color: rgba(255,255,255,0.4); letter-spacing: 0.5px; }
  .login__stat-divider { width: 1px; background: rgba(255,255,255,0.12); align-self: stretch; }

  .login__right { flex: 1; display: flex; align-items: center; justify-content: center; padding: 48px 40px; background: #f4f6f4; }
  .login__card { width: 100%; max-width: 400px; animation: loginFadeUp 0.5s ease both; }
  @keyframes loginFadeUp { from { opacity: 0; transform: translateY(24px); } to { opacity: 1; transform: translateY(0); } }
  .login__card-title { font-family: 'Playfair Display', serif; font-size: 32px; font-weight: 700; color: #1a1a1a; margin-bottom: 8px; }
  .login__card-sub { font-size: 14px; color: #888; margin-bottom: 40px; line-height: 1.5; }
  .login__form { display: flex; flex-direction: column; gap: 20px; }
  .login__field { display: flex; flex-direction: column; gap: 7px; }
  .login__label { font-size: 12px; font-weight: 600; color: #444; letter-spacing: 0.4px; text-transform: uppercase; }
  .login__input-wrap { position: relative; display: flex; align-items: center; }
  .login__input-icon { position: absolute; left: 14px; color: #bbb; font-size: 15px; pointer-events: none; transition: color 0.2s; }
  .login__input {
    width: 100%; background: #fff; border: 1.5px solid #e4e8e4; border-radius: 10px;
    padding: 13px 14px 13px 42px; font-size: 14px; color: #222; outline: none;
    transition: border-color 0.2s, box-shadow 0.2s; font-family: 'DM Sans', sans-serif; box-sizing: border-box;
  }
  .login__input::placeholder { color: #ccc; }
  .login__input:focus { border-color: #1b5e20; box-shadow: 0 0 0 3px rgba(27,94,32,0.08); }
  .login__input-wrap:focus-within .login__input-icon { color: #1b5e20; }
  .login__eye-btn { position: absolute; right: 14px; background: none; border: none; cursor: pointer; color: #bbb; font-size: 15px; padding: 0; display: flex; align-items: center; transition: color 0.2s; }
  .login__eye-btn:hover { color: #555; }
  .login__forgot-row { display: flex; justify-content: flex-end; margin-top: -8px; }
  .login__forgot { font-size: 12.5px; color: #1b5e20; text-decoration: none; font-weight: 500; cursor: pointer; background: none; border: none; padding: 0; transition: color 0.2s; }
  .login__forgot:hover { color: #3db87a; }
  .login__submit {
    width: 100%; background: #1b5e20; color: #fff; border: none; border-radius: 10px;
    padding: 14px; font-size: 15px; font-weight: 600; cursor: pointer;
    font-family: 'DM Sans', sans-serif; letter-spacing: 0.3px;
    transition: background 0.2s, transform 0.15s, box-shadow 0.2s;
    margin-top: 4px; display: flex; align-items: center; justify-content: center; gap: 8px;
  }
  .login__submit:hover { background: #2e7d32; box-shadow: 0 6px 20px rgba(27,94,32,0.25); transform: translateY(-1px); }
  .login__submit:active { transform: translateY(0); }
  .login__submit:disabled { opacity: 0.7; cursor: not-allowed; transform: none; }
  .login__spinner { width: 16px; height: 16px; border: 2px solid rgba(255,255,255,0.3); border-top-color: #fff; border-radius: 50%; animation: loginSpin 0.7s linear infinite; }
  @keyframes loginSpin { to { transform: rotate(360deg); } }
  .login__error { background: #fff0f0; border: 1px solid #ffc9c9; border-radius: 8px; padding: 10px 14px; font-size: 13px; color: #c62828; display: flex; align-items: center; gap: 8px; animation: loginFadeUp 0.3s ease; }

  @media (max-width: 900px) {
    .login__left { width: 42%; padding: 40px 36px; }
    .login__left-title { font-size: 36px; }
  }
  @media (max-width: 680px) {
    .login__page { flex-direction: column; }
    .login__left { width: 100%; padding: 36px 28px; min-height: 220px; justify-content: center; gap: 24px; }
    .login__left-body { display: none; }
    .login__left-stats { display: none; }
    .login__right { padding: 36px 24px; }
    .login__card { max-width: 100%; }
  }
  @media (max-width: 400px) {
    .login__right { padding: 28px 16px; }
    .login__card-title { font-size: 26px; }
  }
`;

export function Login() {
  const [email,        setEmail]        = useState("");
  const [password,     setPassword]     = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading,      setLoading]      = useState(false);
  const [error,        setError]        = useState("");

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!email)    return setError("Please enter your email address.");
    if (!password) return setError("Please enter your password.");
    if (!/\S+@\S+\.\S+/.test(email)) return setError("Please enter a valid email address.");

    setLoading(true);
    try {
      const { data } = await axios.post(`${BASE_URL}/api/admin/login`, { email, password });

      const token = data?.token ?? data?.data?.token ?? data?.accessToken;
      if (!token) {
        setError("Login succeeded but no token was returned.");
        return;
      }

      // Persist token
      localStorage.setItem("adminToken", token);
      localStorage.setItem("adminUser", JSON.stringify(data.data)); // ← add this

      // Attach to all future axios requests
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

      navigate("/dashboard");
    } catch (err) {
      const message =
        err?.response?.data?.message ||
        err?.response?.data?.error   ||
        "Invalid email or password. Please try again.";
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <style>{styles}</style>
      <div className="login__page">

        {/* Left Panel */}
        <div className="login__left">
          <div className="login__left-diamond" />
          <div className="login__left-line" />

          <div className="login__logo">
            <img src={Logo} alt="Jeyshawn logo" />
          </div>

          <div className="login__left-body">
            <p className="login__left-label">Welcome back</p>
            <h2 className="login__left-title">
              Built for<br />
              <span>Excellence</span> &<br />
              Precision.
            </h2>
            <p className="login__left-desc">
              Manage projects, teams, and operations from one unified dashboard built for world-class engineering.
            </p>
          </div>

          <div className="login__left-stats">
            <div className="login__stat">
              <span className="login__stat-num">20+</span>
              <span className="login__stat-label">Projects</span>
            </div>
            <div className="login__stat-divider" />
            <div className="login__stat">
              <span className="login__stat-num">100%</span>
              <span className="login__stat-label">Completion</span>
            </div>
            <div className="login__stat-divider" />
            <div className="login__stat">
              <span className="login__stat-num">105K</span>
              <span className="login__stat-label">Safe Hours</span>
            </div>
          </div>
        </div>

        {/* Right Panel */}
        <div className="login__right">
          <div className="login__card">
            <h1 className="login__card-title">Sign in</h1>
            <p className="login__card-sub">Enter your credentials to access the admin dashboard.</p>

            <form className="login__form" onSubmit={handleSubmit}>

              {error && (
                <div className="login__error">
                  <span>⚠</span> {error}
                </div>
              )}

              {/* Email */}
              <div className="login__field">
                <label className="login__label">Email Address</label>
                <div className="login__input-wrap">
                  <input
                    className="login__input"
                    type="email"
                    placeholder="you@company.com"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    autoComplete="email"
                  />
                  <span className="login__input-icon">✉</span>
                </div>
              </div>

              {/* Password */}
              <div className="login__field">
                <label className="login__label">Password</label>
                <div className="login__input-wrap">
                  <input
                    className="login__input"
                    type={showPassword ? "text" : "password"}
                    placeholder="Enter your password"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    autoComplete="current-password"
                  />
                  <span className="login__input-icon">🔒</span>
                  <button
                    type="button"
                    className="login__eye-btn"
                    onClick={() => setShowPassword(p => !p)}
                    tabIndex={-1}
                  >
                    {showPassword ? "🙈" : "👁"}
                  </button>
                </div>
              </div>

              {/* Forgot */}
              <div className="login__forgot-row">
                <button type="button" className="login__forgot">Forgot password?</button>
              </div>

              {/* Submit */}
              <button className="login__submit" type="submit" disabled={loading}>
                {loading ? (
                  <><span className="login__spinner" /> Signing in…</>
                ) : (
                  "Sign In →"
                )}
              </button>

            </form>
          </div>
        </div>

      </div>
    </>
  );
}

export default Login;